import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EditTradeOrders from '../../Pages/CreateHPool/CreateHPoolSignTransaction/EditTradeOrders/EditTradeOrders';

export const OrdersContext = createContext({ selectedToken: null, onPrev: () => {}, hpool: {} });
function EditOrderDetails({ selectedToken, onPrev, hpool }) {
  return (
    <div>
      <OrdersContext.Provider value={{ selectedToken, onPrev, hpool }}>
        <EditTradeOrders />
      </OrdersContext.Provider>
    </div>
  );
}

const mapStateToProps = ({ createHPool }) => ({
  hpool: createHPool.hpool,
});

export default connect(mapStateToProps)(EditOrderDetails);
EditOrderDetails.defaultProps = {
  selectedToken: null,
};

EditOrderDetails.propTypes = {
  selectedToken: PropTypes.object,
  hpool: PropTypes.object.isRequired,
  onPrev: PropTypes.func.isRequired,
};
